/* eslint-disable prefer-template */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable new-cap */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  Typography,
  Grid,
  Button,
  IconButton,
} from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import '../../shared/arial';
import Loader from 'react-loader-spinner';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { Loading, generateWordDocument, exportXlsx } from '../../helpers/utils';
import examServices from '../../redux/services/examServices';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import ScaleExams from './ScaleExams';

const getFormatedDate = (date) => {
  if (date === null) {
    return 'No date';
  }
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return (`${date.toLocaleDateString('fr-EU')} - ${hours}h${minutes <= 9 ? '0' : ''}${minutes}`);
};

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ExamResultsWithAnswers = ({ examIdentifier, examModalities }) => {
  const [loadingState, setLoadingState] = useState(true);
  const [substring, setSubstring] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [exam, setExam] = useState();
  const [totalPapers, setTotalPapers] = useState(0);
  const [examModality, setExamModality] = useState({});
  const refTable = useRef();

  const [examData, setExamData] = useState([]);

  const classes = useStyles();

  const columns = [
    {
      title: 'Corrector',
      field: 'teacherId',
      width: '5%',
      render: (rowData) => {
        if (rowData.teacherId && rowData.teacherId.firstname) {
          return <Typography variant="caption">{`${rowData.teacherId.firstname} ${rowData.teacherId.name}`}</Typography>;
        }
        return <Typography variant="caption">No corrector assigned</Typography>;
      },
    },
    {
      title: 'Firstname',
      field: 'firstname',
      width: '5%',
    },
    {
      title: 'Name',
      field: 'name',
      width: '5%',
      defaultSort: 'asc',
    },
    {
      title: 'Answer',
      field: 'answer',
      width: '40%',
      render: (rowData) => (
        <>
          {rowData.answer && rowData.answer !== null
            ? (
              <CloudDownload
                style={{ marginRight: '5px', cursor: 'pointer' }}
                onClick={() => generateWordDocument(rowData.firstname, rowData.name, rowData.answer)}
                // color="primary"
              />
            )
            : <Typography variant="caption">n/a</Typography>}
        </>
      ),
    },
    {
      title: 'Problem',
      field: 'fetched',
      width: '5%',
    },
    {
      title: 'TimeStamp',
      field: 'created_at',
      width: '5%',
      render: (rowData) => `${getFormatedDate(rowData.created_at ? new Date(rowData.created_at) : null)}`,
    },
    {
      title: 'Grade',
      field: 'results.grade',
      render: (rowData) => <ScaleExams rowData={rowData} examModality={examModality} />,
    },
    {
      title: 'Comment',
      field: 'results.comment',
      render: ({ comment }) => {
        if (comment && comment !== null && comment !== 'n/a') {
          return (
            <Typography style={{ color: '#757575', fontSize: '13px' }}>
              {comment}
            </Typography>
          );
        }
        return <Typography variant="caption" style={{ color: '#8f8f8f' }}>No comment</Typography>;
      },
    },
  ];

  const loadExamResults = async () => {
    setLoadingState(true);
    const fetchedData = [];
    const examStudents = [];
    const examRes = await elearningDetailsServices.getElearningDetailWithStudents(examIdentifier);
    if (examRes) {
      setExam(examRes.exam);
      if (examRes.students) {
        examRes.students.forEach((student) => {
          if (parseFloat(student.semester, 10) === parseFloat(examRes.exam.semester, 10)
          || parseFloat(student.semester, 10) - 1 === parseFloat(examRes.exam.semester, 10)
          || student.catchUp?.includes(parseFloat(examRes.exam.semester, 10))) {
            examStudents.push(student);
          }
        });
        let papers = 0;
        await Promise.all(examStudents.map(async (student) => {
          const examResultRes = await examServices.getExamPDFResults(student._id, examIdentifier);
          const studentObj = {
            created_at: null,
            userId: student._id,
            teacherId: 'n/a',
            firstname: student.firstname,
            name: student.name,
            answer: null,
            fetched: 'No problem',
            grade: 'n/a',
            comment: 'n/a',
          };
          if (examResultRes && examResultRes !== null) {
            studentObj.created_at = examResultRes.created_at;
            studentObj.answer = examResultRes.answer;
          }
          examRes?.exam?.results?.forEach((result) => {
            if (result.userId === student._id && result.grade !== undefined) {
              studentObj.grade = result.grade;
              studentObj.teacherId = result.teacherId || 'No corrector assigned';
              const grades = Object.values(result.grade);
              const sum = grades.reduce((a, b) => a + b);
              if (sum > 0) papers += 1;
            }
            if (result.userId === student._id && result.comment && result.comment.length > 0) {
              studentObj.comment = result.comment;
            }
          });
          fetchedData.push(studentObj);
        }));
        setTotalPapers(papers);
        setExamData(fetchedData);
      }
    }
    setLoadingState(false);
  };

  useEffect(() => {
    examModalities.forEach((examModalityItem) => {
      if (examModalityItem.value === exam.modality) {
        setExamModality(examModalityItem);
      }
    });
  }, [exam]);

  useEffect(() => {
    loadExamResults();
  }, []);

  const handleRedirect = () => {
    setRedirect(true);
  };

  const handleAllPapers = () => {
    examData.forEach((studentResult) => {
      if (studentResult.answer.length > 0) {
        generateWordDocument(studentResult.firstname, studentResult.name, studentResult.answer);
      }
    });
  };

  if (redirect) {
    return <Redirect to="/list" />;
  }
  return (
    <div className={classes.root}>
      <Container className="dashboard">
        <Row>
          <Col md={1} style={{ marginBottom: '20px' }}>
            <IconButton
              aria-label="delete"
              onClick={() => handleRedirect()}
            >
              <ArrowBackIcon />
            </IconButton>
          </Col>
          <Col md={10} style={{ marginBottom: '20px' }}>
            {(loadingState === false && (exam.semester <= 5 && exam.semester >= 3) && examData && examData.length > 0)
              && <Button variant="contained" color="primary" style={{ marginBottom: '25px', width: '30%', marginLeft: '35%' }} onClick={handleAllPapers}>Télécharger toute les copies</Button>}
          </Col>
        </Row>
      </Container>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {
            loadingState === false
              ? (
                <MaterialTable
                  style={{ width: '100%' }}
                  title={`Results for ${exam?.name ? exam.name.replace(/\b(level 1|level 2)\b\s*$/i, '') : ''} - Total papers: ${totalPapers}`}
                  columns={columns}
                  isLoading={loadingState}
                  components={{
                    OverlayLoading: () => (<Loading />),
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: loadingState ? '' : 'No results to display',
                    },
                  }}
                  tableRef={refTable}
                  data={examData}
                  options={{
                    search: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportCsv: () => {
                      const examObj = { ...exam } || null;
                      const finalResults = [];
                      const resultsArr = [...examData];
                      resultsArr.sort((a, b) => a.name > b.name);
                      resultsArr.forEach((elem) => {
                        const item = {};
                        if (exam.anonymous) {
                          item['Numéro'] = elem.number;
                        } else {
                          item.Nom = elem.name;
                          item['Prénom'] = elem.firstname;
                        }
                        // searching for grade since it's not in the base obj of the student
                        exam?.results?.forEach((result) => {
                          if (result.userId === elem.userId && result.grade !== undefined) {
                            const gradeArr = Object.values(elem.grade);
                            const totalGrade = gradeArr.reduce((a, b) => a + b);
                            let total = 0;
                            examModality.grades.forEach((gradeItem) => {
                              item[gradeItem.gradeFr] = elem.grade[gradeItem.gradeEn];
                              total += gradeItem.value;
                            });
                            if (total === 20) {
                              item['Note (/20'] = totalGrade;
                            } else {
                              item['Score (/' + total + ')'] = totalGrade;
                              item['Note (/20'] = (totalGrade / total) * 20;
                            }
                          }
                        });
                        if (elem.grade === undefined) {
                          item.grade = 'n/a';
                        }
                        if (exam && exam !== null) {
                          exam.results.forEach((result) => {
                            if (result.userId === item.userId) {
                              item.Commentaire = result.comment;
                            }
                          });
                        }
                        finalResults.push(item);
                      });
                      const today = new Date();
                      const sortedArr = finalResults.sort((a, b) => ((
                        a.Nom > b.Nom)
                        ? 1
                        : ((b.Nom > a.Nom)
                          ? -1
                          : 0)
                      ));
                      exportXlsx(sortedArr, `${examObj.name.replace(/\b(level 1|level 2)\b\s*$/i, '')}_${today.getDate()}/${today.getMonth() + 1}`);
                    },
                    exportAllData: true,
                    pageSize: examData.length,
                    sorting: true,
                    tableLayout: 'auto',
                  }}
                  onRowClick={(e, data) => {
                    if (substring !== data.userId) {
                      setSubstring(data.userId);
                    } else {
                      setSubstring(null);
                    }
                  }}
                />
              )
              : <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
          }
        </Grid>
      </Grid>
    </div>
  );
};

export default ExamResultsWithAnswers;
